import apiClient from 'utils/apiClient';
import { saveSchoolWithVerification } from 'utils/schoolSave';

const baseUrl = 'v2/schools';

const getSchools = (params = {}) => apiClient.get(baseUrl, params);

const getSchoolbyId = (schoolId) =>
  apiClient.get(`${baseUrl}/${schoolId}`, {
    params: { for_dashboard: true },
  });

const getSchoolResource = ({ schoolId, type, params = null }) =>
  apiClient.get(
    `${baseUrl}/${schoolId}/${type}?dashboard_mode=true${
      type === 'courses' ? '&include_user_generated=true' : ''
    }`,
    {
      params,
    },
  );

const createSchool = (schoolData) =>
  saveSchoolWithVerification(
    apiClient,
    'post',
    schoolData.school_name,
    schoolData,
  );

const updateSchool = (schoolId, schoolData) =>
  saveSchoolWithVerification(apiClient, 'put', schoolId, schoolData);

const updateCollege = (schoolId, collegeData) =>
  apiClient.patch('v2/admin/colleges', { ...collegeData, school_id: schoolId });

const enableFeature = (schoolId, feature) =>
  apiClient.post(`${baseUrl}/${schoolId}/features/${feature}`);

const disableFeature = (schoolId, feature) =>
  apiClient.delete(`${baseUrl}/${schoolId}/features/${feature}`);

const schoolsService = () => ({
  getSchools,
  getSchoolbyId,
  getSchoolResource,
  createSchool,
  updateSchool,
  updateCollege,
  enableFeature,
  disableFeature,
});

export default schoolsService;
